// extracted by mini-css-extract-plugin
export default {"container":"FeatureFullImage-module--container--qlqWl"};